import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CentralAfricanRepublicFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14464'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14464)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#083D96'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2667H20V6.53333H0V10.2667Z'
					fill='#37AE39'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#FFD13F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61914 14H12.381V0H7.61914V14Z'
					fill='#E42346'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33287 2.41267L2.49318 2.9993L2.80299 2.0354L1.97422 1.43405L3.00539 1.42495L3.33287 0.466675L3.66035 1.42495L4.69152 1.43405L3.86274 2.0354L4.17256 2.9993L3.33287 2.41267Z'
					fill='#FFD03B'
				/>
			</g>
		</svg>
	);
};

export default CentralAfricanRepublicFlagIcon;
